import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',           // MUI‑Standard‑Blau
        },
        secondary: {
            main: '#9c27b0',
        },
    },

});

export default theme;
